define('models/pages/favorites/goods',['require','underscore','lib/utils','chaplin','models/base/model','models/base/collection','models/pages/favorites/goodsItem','models/filter/index','models/filter-list'],function(require) {
    'use strict';

    var _ = require('underscore'),
        utils = require('lib/utils'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection'),
        GoodsItem = require('models/pages/favorites/goodsItem'),
        FilterModel = require('models/filter/index'),
        FilterListModel = require('models/filter-list');

    function _preprocessData(items) {
        var i, li, item;

        for (i=0, li = items.length; i<li; i++) {
            item = items[i];

            item.isFavorite = item.isFavorite + '';

            item.idx = i;

            item.searchString = [
                item.typeName ? item.typeName.toLowerCase() : '',
                item.countryName ? item.countryName.toLowerCase() : '',
                item.goodsName ? item.goodsName.toLowerCase() : ''
            ].join(' ');
        }

        return items;
    }

    var FavoritesGoodsCollection = Collection.extend({
        model: GoodsItem,
        comparator: function(model){
            return model.get('typeName') + model.get('goodsName') + model.get('countryName');
        },
        initialize: function() {
            Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        }
    });

    var FavoritesGoods = Model.extend({
        urlPath: '/favorite-goods',
        defaults: {
            selected: null,
            search: '',
            items: [],
            favFilter: ''
        },
        constructor: function(data) {
            var _this = this;

            // var goods = new FavoritesGoodsCollection(data ? data.goods : [], { parse: true });

            // this.goods = goods;

            // this.on('beforeLoad', function() {
            //     this.goods.beginSync();
            // });

             this.on('afterLoad', function() {
                 this.trigger('loading');
             });

            this.on('change:search', this.onSearchChanged);

            this.filter = new FilterModel({ showSummary: true });
            this.filter.on('filterChanged', _.bind(this.onFilterChanged, this));

            this.filterList = new FilterListModel({ type: 'traderFavsGoods' });
            this.filterList.setFilter(this.filter);

            // goods.on('change:selected', function(model, value) {
            //     if (value) {
            //         goods.each(function(item) {
            //             if (item !== model && item.get('selected')) {
            //                 item.set('selected', false);
            //             }
            //         });
            //         _this.set('selected', model);
            //     }
            // });

            this.filterSetupData = {
                schema: [
                    {
                        name: 'countryName',
                        caption: 'Страна'
                    },
                    {
                        name: 'typeName',
                        caption: 'Тип'
                    },
                    {
                        name: 'goodsName',
                        caption: 'Сорт'
                    }
                ],
                source: []
            };

            Model.apply(this, arguments);
        },
        onSearchChanged: function(){
            this.searchedData = utils.applySearch(this.filter.get('filtered'), this.get('search'));
            this.set('items', this.searchedData);
            // this.goods.reset(this.searchedData, {silent: true});
            this.trigger('filterChanged');
        },
        onFilterChanged: function() {
            this.onSearchChanged();
        },
        load: function() {
            this.filterList.load();

            return Model.prototype.load.apply(this, arguments);
        },
        parse: function(data) {
            data = _preprocessData(data);


            var selected = this.get('selected');
            // this.goods.reset(data, { silent: true });
            // if (selected) {
            //     var found = this.goods.findWhere({ ID: selected.get('ID') });
            //     if (found) {
            //         found.set('selected', true);
            //     }
            // }

            this.filterSetupData.source = data;
            this.filter.setup(this.filterSetupData);

            this.filter.trigger('filterChanged');

            return { items: data };
        },
        urlParams: function() {
            var params = Model.prototype.urlParams.apply(this, arguments);
            params.filter = this.get('favFilter');
            return params;
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.filter.dispose();
            this.filterList.dispose();
            // this.goods.dispose();
            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return FavoritesGoods;
});

